module.exports = __webpack_public_path__ + "img/2023-01-09c_2.5f872938.jpg";